export default __webpack_public_path__ + "static/media/ossscreen13.f43b5865.png";